import { styled } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

export const ButtonContainer = styled("div")(() => ({
  padding: "16px 24px",
  borderRadius: "0px 0px 12px 12px",
  borderRight: `1px solid ${colors.gray200}`,
  borderBottom: `1px solid ${colors.gray200}`,
  borderLeft: `1px solid ${colors.gray200}`,
  background: colors.white,
  display: "flex",
  justifyContent: "flex-end",
}));

const styles = makeStyles(() => ({
  mainDiv: {
    padding: "32px",
    backgroundColor: colors.white,
  },
  container: {
    backgroundColor: colors.white,
  },
  tabDetails: {
    padding: "24px !important",
  },
  uiTab: {
    height: "100% !important",
  },
  transshipmentMaintenanceHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: 64,
    boxShadow: "inset 0px -1px 0px #F0F0F0",
    background: "#F8FAFC",
    fontFamily: "'Manrope', sans-serif",
    padding: "15px 32px",
  },
  transshipmentMaintenanceHeaderBreadcrumb: {
    "& ol": {
      alignItems: "flex-end",
    },
  },
  transshipmentMaintenanceHeaderBreadcrumbTitle: {
    fontSize: 18,
    lineHeight: "24px",
    fontWeight: 600,
    color: "#38CFC4",
    fontFamily: `'Manrope', sans-serif`,
    "&.active": {
      color: "#465869",
    },
    "&.linkToTransshipments": {
      cursor: "pointer",
    },
  },
}));

export default styles;
